<!-- eslint-disable vue/no-v-html -->
<template>
  <base-card
    ref="container"
    class="position-relative"
  >
    <base-heading>Products Views</base-heading>
    <div
      class="position-absolute m-3"
      style="top: 0; right: 0;"
    >
      <slot name="actions" />
    </div>
    <products-carousel
      :products="itemsWithCount"
      :width="carouselWidth"
      :per-slide="5"
      :no-tooltip="false"
      :show-size="false"
      :click-to-new-tab="false"
      @click="openModal"
    />
    <client-email-events-container
      v-if="showEventsModal"
      :show="showEventsModal"
      :customer="modalCustomer"
      :subject="modalSubject"
      :date="modalDate"
      @closed="onEventsModalClosed"
    />
    <base-modal
      id="ProductView"
      :title="modalTitle || ' '"
      :show="showModal"
      @closed="showModal = false"
    >
      <template #header="{ title }">
        <base-skeleton
          v-if="scrapperLoading"
          no-background
        >
          <div
            class="skeleton__item"
            style="width: 50%"
          />
        </base-skeleton>
        <div
          v-else
          class="d-flex align-items-center"
        >
          <base-text class="productTitle">
            {{ title }}
          </base-text>
          <base-text
            size="m"
            light
            class="ml-1"
          >
            -&nbsp;{{ modalSubtitle }}
          </base-text>
        </div>
      </template>
      <hr class="divider mt-n2 mb-4 pb-2 mx-3">
      <div class="row justify-content-between mx-3">
        <div
          v-if="modalThumbnail"
          class="col-3  spillover-safe"
        >
          <base-thumbnail
            large
            :src="modalThumbnail"
            cover
          />
        </div>
        <div :class="modalThumbnail ? 'col-9' : 'col-12'">
          <base-skeleton
            v-if="scrapperLoading"
            no-background
          >
            <div
              class="base-skeleton skeleton__item"
              width="100%"
            />
          </base-skeleton>
          <base-text
            v-else
            break-word
            size="m"
            light
          >
            {{ modalUrl }}
          </base-text>
          <div class="table mt-3">
            <div class="row header my-2">
              <base-text
                medium
                size="s"
                class="col-4"
              >
                DATE AND TIME
              </base-text>
              <base-text
                medium
                size="s"
                class="col"
              >
                CLIENT EMAIL
              </base-text>
              <base-text
                medium
                size="s"
                class="col-1 text-center"
              >
                VIEWS
              </base-text>
            </div>
            <div v-if="scrapperLoading">
              <base-skeleton
                v-for="n in 4"
                :key="n"
                :opacity="0 + (1 /n)"
                class="row px-3"
              >
                <div
                  v-for="(col, m) in ['col-4', 'col', 'col-1']"
                  :key="`skel_item_${m}`"
                  :class="col"
                >
                  <div
                    class="skeleton__item"
                    style="max-width: 80%"
                  />
                </div>
              </base-skeleton>
            </div>
            <div v-else>
              <div
                v-for="(product, index) in modalProducts"
                :key="`product_clicks_${index}`"
                class="row py-2 body"
              >
                <base-text
                  light
                  size="m"
                  class="col-4"
                >
                  <span
                    v-html="fixTimeSpacing($options.filters.nicedate(product.datetime*1000, 'custom', 'M/DD/YY h:mmA'))"
                  />
                  <!-- {{ $moment(product.datetime*1000) | nicedate('custom', 'M/DD/YY h:mmA') }} -->
                </base-text>
                <base-text
                  id="productName"
                  regular
                  size="m"
                  class="col"
                >
                  {{ product.email || 'Anonymous' }}
                </base-text>
                <base-text
                  v-if="isAppointment"
                  light
                  size="m"
                  class="col-1 text-center black clickable underline"
                  @click="viewInvitationEventDetails(product, outreachId)"
                >
                  {{ product.total }}
                </base-text>
                <base-text
                  v-else
                  light
                  size="m"
                  class="col-1 text-center black clickable underline"
                  @click="viewEditEventDetails(product, outreachId)"
                >
                  {{ product.total }}
                </base-text>
              </div>
            </div>
          </div>
        </div>
      </div>
    </base-modal>
  </base-card>
</template>
<script type="text/javascript">
import axios from 'axios';
import ClientEmailEventsContainer from '@/components/Widgets/ClientHistory/ClientEmailEventsContainer';
import { API_ROOT } from '../../../config';
import api from '../../../_api';

export default {
  components: { ClientEmailEventsContainer },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showEventsModal: false,
      modalCustomer: '',
      modalSubject: '',
      modalDate: null,
      carouselWidth: 0,
      showModal: false,
      modalUrl: '',
      modalTitle: '',
      modalSubtitle: '',
      modalThumbnail: '',
      modalProducts: [],
      Product: [],
      scrapperLoading: false,
      scrapperError: false,
    };
  },
  computed: {
    isAppointment() {
      return this.$route.name === 'AppointmentActivity';
    },
    appointmentId() {
      return this.$route.params.appointmentId;
    },
    appointment() {
      return this.$store.state.appointments.item;
    },
    outreachId() {
      if (this.isAppointment) return null;
      const { id, outreach } = this.$route.params;
      return id || outreach;
    },
    event() {
      return this.$route.params.event;
    },
    customerId() {
      return this.$route.params.customerId;
    },
    itemsWithCount() {
      return this.items.map((item, index) => {
        let isBrokenImage = false;
        if (item.thumb === 'https://s4o.imgix.net/media/public/no-product.png') {
          isBrokenImage = true;
        }
        let plural = '';
        if (item.view_count !== 1) {
          plural = 's';
        }
        return {
          footer: `${item.view_count} Click${plural}`,
          thumb_broken: isBrokenImage,
          ...item,
        };
      });
    },
  },
  watch: {
    showModal(newVal) {
      // reset data on closing modal
      if (!newVal) {
        this.modalUrl = '';
        this.modalTitle = '';
        this.modalSubtitle = '';
        this.modalThumbnail = '';
        this.modalProducts = [];
      }
    },
  },
  mounted() {
    this.$nextTick().then(() => {
      this.carouselWidth = this.$refs.container.$el.clientWidth;
    });
    if (this.isAppointment
      && `${this.$store.state.appointments.item.pk}` !== `${this.appointmentId}`) this.$store.dispatch('appointments/getReportItem', this.appointmentId);
    if (!this.isAppointment) {
      this.$store.dispatch('outreachs/fetchStats', { id: this.outreachId, customerId: this.customerId });
      if (this.$route.query.group) this.$store.dispatch('groups/fetchGroup', this.$route.query.group);
    }
  },
  methods: {
    viewEditEventDetails(product, outreach) {
      const sent_date = new Date((product?.datetime) * 1000).toString();
      if (this.isAppointment) return;
      this.showModal = false;

      this.modalSubject = `<div style="display:flex; 
                            font-size:15px; line-height: 18px;">
                              <div style=" font-family: 'Tiempos'; font-weight:600; font-style: normal;">
                                ${this.Product?.brand.name}
                                </div>&nbsp-&nbsp
                                <div style="font-family: 'SilkaLight'; font-weight:100;">
                                  ${this.Product?.title}
                              </div>
                            </div>`;
      this.modalDate = sent_date;

      api.get(`${API_ROOT}/outreach/${outreach}/stats`)
        .then((response) => {
          if (response.status === 200) {
            const data_ = response.data.edit.sent_to;
            if (data_.total_customer > 1) {
              this.modalCustomer = {
                first_name: data_.display,
                last_name: '',
                email: product?.email,
              };
            } else {
              this.modalCustomer = {
                first_name: data_?.to_customers.first_name,
                last_name: data_?.to_customers.last_name,
                email: product?.email,
              };
            }

            this.showEventsModal = true;
          }
        }).catch(() => {
          this.scrapperError = true;
        }).finally(() => {
          this.scrapperLoading = false;
        });
    },
    viewInvitationEventDetails(product, customer) {
      if (!this.isAppointment) return;
      // prepare modal data
      this.modalSubject = this.$options.filters.striphtml(this.appointment.subject);
      this.modalDate = this.appointment.start_date;
      this.modalCustomer = customer || {
        first_name: 'Anonymous',
        last_name: '',
        email: '--',
        // anon,
      };
      // this.modalCustomer.invitationId = invitationId;
      // show
      this.showEventsModal = true;
    },
    onEventsModalClosed() {
      this.showEventsModal = false;
      this.modalSubject = '';
      this.modalDate = null;
      this.modalCustomer = null;
    },
    fixTimeSpacing(value) {
      // This fixes the space between hours and minutes
      return value.replace(':', '<span style="letter-spacing: 1px;">:</span>');
    },
    openModal(params) {
      const { _props: { pk, url } } = params;
      const product = this.items.find((p) => {
        if (pk === -1) {
          return p.site_url === url && !p.pk;
        }
        return p.pk === pk;
      });
      this.modalUrl = product.site_url;
      if (product.brand) {
        this.modalTitle = product.brand.name;
        this.modalSubtitle = product.title;
        this.modalThumbnail = product.thumb === 'https://s4o.imgix.net/media/public/no-product.png' ? `${window.location.origin}/img/blank-product.png` : product.thumb;
        this.modalProducts = product.view_data;
        this.showModal = true;
        this.modalCustomer = product;
        this.Product = product;
      } else {
        // on else call scrapper
        this.scrapperLoading = true;
        this.showModal = true;
        axios.post('https://us-central1-stylelab-scrap.cloudfunctions.net/stylelab-scrap-v3-dev-first', {
          url: product.site_url,
        }).then((response) => {
          this.modalTitle = response.data.brand.name;
          this.modalSubtitle = response.data.title;
          this.modalProducts = product.view_data;
          this.Product = product;
        }).catch(() => {
          this.scrapperError = true;
        }).finally(() => {
          this.scrapperLoading = false;
        });
      }
    },
    // loadContent() {
    //   // Fetch item
    //   this.$store.dispatch('products/fetchItem', this.url).then(() => {});
    // },
  },
};
</script>
<style lang="scss"
  scoped>
#productName {
font-size: 14px;
font-family: 'SilkaMedium';
line-height: 16px;
}
#ProductView {
  ::v-deep .card-body {}

  ::v-deep .modal-header {
    display: inline;
    padding: 32px 30px 0 32px;
    background-color: transparent !important;

    >button {
      transform: scale(1.45);
      margin-bottom: -1px;
    }
  }

  ::v-deep .modal-content {
    border-radius: 0;
  }
}

.table {
  .header {
    background-color: $bg-dashboard;
    padding: 5px 23px 3px 26px;

    .base-text {
      color: $gray;
      padding: 0;
    }
  }

  .body {
    padding: 5px 23px 3px 26px;

    .base-text {
      padding: 0;
      color: $black;
    }
  }
}

.spillover-safe {
    /* https://helloseer.monday.com/boards/1158447322/pulses/1444503151 */
    overflow: hidden;

    // Minor hack to prevent the spillover
    // Note: This should be remove when base-thumbnail is updated with 100% width
    &::v-deep img {
      width: 100%;
    }
}
.productTitle {
  font-size: 22px;
  font-weight: 600;
  font-family: 'Tiempos';
  font-style: normal;
}
</style>
